import React, {useEffect, useState} from "react";

const FullscreenButton = ({children, ...props}) => {
    const themeClasses = {
        'default': 'bg-lavender text-white border-transparent',
        'light': 'bg-lavender-8 text-lavender border-transparent',
        'tab-inactive': 'bg-white text-lavender border-lavender border-solid',
        'danger': 'bg-danger text-white border-transparent'
    }
    const [theme, setTheme] = useState()
    useEffect(() => {
        setTheme(props.activestate || 'default')
    }, [props.disabled, props.activestate])
    return (
        <button
            {...props}
            className={`
            border rounded-2xl px-4 min-h-[42px] text-base text-medium 
            disabled:bg-lavender-8 disabled:text-lavender-30 disabled:border-transparent 
            ${themeClasses[theme]} ${props.className}
        `}
        >{children}</button>
    )
}

export default FullscreenButton
